<ng-content select=".initial-route-shell"></ng-content>
<!--body class="app header-fixed sidebar-fixed aside-menu-fixed" [ngClass]="{'sidebar-show':false}"-->
<body class="app header-fixed" [ngClass]="{'sidebar-show':getSideBar(), 'mobile-menu-open':getSideBar()}"  >
  <header class="app-header navbar">
    <button
      type="button"
      class="mobile-menu-toggle"
      (click)="toggleSideBar()"
      [attr.aria-expanded]="getSideBar()"
      aria-label="Open menu">
      <i class="fas fa-bars"></i>
    </button>

    <a class="navbar-brand" href="/all-referrals" (click)="clearSearch()"><span class="navbar-brand-full"><small>MyReferralPromoCode</small></span></a>

    <ul class="nav navbar-nav d-md-down-none">
      <li class="nav-item px-3"><a class="nav-link" href="/my" (click)="clearSearch()">Malaysia</a></li>
      <li class="nav-item px-3"><a class="nav-link" href="/sg" (click)="clearSearch()">Singapore</a></li>
      <li class="nav-item px-3"><a class="nav-link" routerLink="/manufacturing-date-checker">Batch Checker</a></li>
      <li class="nav-item px-3"><a class="nav-link" routerLink="/contact-us">Contact Us</a></li>
      <li class="nav-item px-3 dropdown d-md-down-none" [ngClass]="{'open show':showDropDown()}" dropdown=""
        placement="bottom right"><a aria-haspopup="true" class="nav-link" data-toggle="dropdown"
          dropdowntoggle="" role="button" [attr.aria-expanded]="showDropDown()" (click)="toggleDropDown()" onmouseover=""
          style="cursor: pointer;">Category <i class="fas fa-caret-down"></i></a>
        <div aria-labelledby="simple-dropdown" class="dropdown-menu dropdown-menu-right dropdown-menu"
          [ngClass]="{'show':showDropDown()}" style="left: auto; right: 0px; top: 100%; transform: translateY(0px);">
          <a class="dropdown-item" (click)="hidePopUp()" routerLink="/all-referrals"><i class="fas fa-globe-asia"></i>
            All </a>
          <a class="dropdown-item" (click)="hidePopUp()" routerLink="/my"><i class="fas fa-globe-asia"></i>
            Malaysia </a>
          <a class="dropdown-item" (click)="hidePopUp()" routerLink="/sg"><i class="fas fa-globe-asia"></i>
            Singapore </a>
          <a class="dropdown-item" (click)="hidePopUp()" routerLink="/e-wallet"><i class="fas fa-wallet"></i> E-wallet
          </a>
          <a class="dropdown-item" (click)="hidePopUp()" routerLink="/cashback"><i class="fas fa-money-bill-wave"></i>
            Cash back </a>
          <a class="dropdown-item" (click)="hidePopUp()" routerLink="/shopping"><i class="fas fa-shopping-cart"></i>
            Shopping </a>
            <a class="dropdown-item" (click)="hidePopUp()" routerLink="/dining"><i class="fas fa-hamburger"></i>
              Dining </a>
            <a class="dropdown-item" (click)="hidePopUp()" routerLink="/investment"><i class="fas fa-hand-holding-usd"></i>
              Investment </a>
              <a class="dropdown-item" (click)="hidePopUp()" routerLink="/cryptocurrency"><i class="fas fa-light fa-coins"></i>
                Cryptocurrency </a>
          <a class="dropdown-item" (click)="hidePopUp()" routerLink="/others"><i class="fas fa-ellipsis-h"></i> Others
          </a>
        </div>
      </li>

      <li class="nav-item px-3 dropdown d-md-down-none" [ngClass]="{'open show':showSortDropDown()}" sortDropdown=""
        placement="bottom right"><a aria-haspopup="true" class="nav-link" data-toggle="sortDropdown"
          dropdowntoggle="" role="button" [attr.aria-expanded]="showSortDropDown()" (click)="toggleSortDropDown()"
          onmouseover="" style="cursor: pointer;">Sort By <i class="fas fa-caret-down"></i></a>
        <div aria-labelledby="simple-dropdown" class="dropdown-menu dropdown-menu-right dropdown-menu"
          [ngClass]="{'show':showSortDropDown()}"
          style="left: auto; right: 0px; top: 100%; transform: translateY(0px);">
          <a class="dropdown-item" href="/all-referrals?sort=alpha" (click)="sortData('alpha'); $event.preventDefault()"><i class="fas fa-sort-alpha-down"></i>
            Alphabetical </a>
          <a class="dropdown-item" href="/all-referrals?sort=recent" (click)="sortData('recent'); $event.preventDefault()"><i class="fas fa-clock"></i>
            Most Recent </a>
        </div>
      </li>
      <li class="nav-item px-3"><a class="nav-link" routerLink="/birthday-freebies-malaysia">Birthday Rewards</a></li>
      <li class="nav-item navbar-search-item" *ngIf="showSearchBar()">
        <div class="navbar-search">
          <i class="fas fa-search"></i>
          <input
            #desktopSearchInput
            type="text"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchTextChange($event)"
            (keyup)="triggerSearch(desktopSearchInput.value)"
            (keyup.enter)="triggerSearch(desktopSearchInput.value)"
            placeholder="Search apps"
            autocomplete="off"
            aria-label="Search referral apps">
          <button *ngIf="searchText" type="button" (click)="clearSearch()" aria-label="Clear search">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </li>
    </ul>

    <ul class="nav navbar-nav ml-auto">
      <li class="nav-item navbar-search-item mobile-navbar-search" *ngIf="showSearchBar()">
        <div class="navbar-search">
          <i class="fas fa-search"></i>
          <input
            #mobileSearchInput
            type="text"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchTextChange($event)"
            (keyup)="triggerSearch(mobileSearchInput.value)"
            (keyup.enter)="triggerSearch(mobileSearchInput.value)"
            placeholder="Search apps"
            autocomplete="off"
            aria-label="Search referral apps">
          <button *ngIf="searchText" type="button" (click)="clearSearch()" aria-label="Clear search">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </li>
      <li class="nav-item dropdown d-md-none" [ngClass]="{'open show':showSortDropDown()}" dropdown="" placement="bottom right"><a aria-haspopup="true"
          class="nav-link" data-toggle="dropdown" dropdowntoggle="" role="button" aria-label="Sort referral apps" [attr.aria-expanded]="showSortDropDown()" (click)="toggleSortDropDown()"><img
            alt="" class="img-avatar sort-icon" src="assets/sortby.png" width="35" height="35"></a>
        <!---->
        <div aria-labelledby="simple-dropdown" class="dropdown-menu dropdown-menu-right" [ngClass]="{'show':showSortDropDown()}"
          style="left: auto; right: 0px;">
          <div class="dropdown-header text-center"><strong>Sort By</strong></div><a class="dropdown-item"
            class="dropdown-item" href="/all-referrals?sort=alpha" (click)="sortData('alpha'); $event.preventDefault()"><i class="fas fa-sort-alpha-down"></i> Alphabetical<span
              class="badge badge-danger"></span></a><a class="dropdown-item" href="/all-referrals?sort=recent" (click)="sortData('recent'); $event.preventDefault()"><i class="fas fa-clock"></i>
            Most Recent<span class="badge badge-warning"></span></a>
        </div>
      </li>
    </ul>
  </header>

  <div (click)="hidePopUp()" class="app-body">
    <button
      *ngIf="getSideBar()"
      type="button"
      class="mobile-sidebar-backdrop"
      (click)="closeSideBar(); $event.stopPropagation()"
      aria-label="Close menu">
    </button>
    <div class="sidebar">
      <nav class="sidebar-nav">
        <ul class="nav">
          <li class="nav-title">Category</li>
          <li class="nav-item">
            <a class="nav-link" (click)="closeSideBar()" routerLink="/all-referrals">
              <i class="fas fa-globe-asia"></i> All
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="closeSideBar()" routerLink="/my">
              <i class="fas fa-globe-asia"></i> Malaysia
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="closeSideBar()" routerLink="/sg">
              <i class="fas fa-globe-asia"></i> Singapore
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="closeSideBar()" routerLink="/birthday-freebies-malaysia">
              <i class="fas fa-gift"></i> Birthday Rewards
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="closeSideBar()" routerLink="/e-wallet">
              <i class="fas fa-wallet"></i> E-wallet
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="closeSideBar()" routerLink="/shopping">
              <i class="fas fa-shopping-cart"></i> Shopping
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="closeSideBar()" routerLink="/cashback">
              <i class="fas fa-money-bill-wave"></i> CashBack
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="closeSideBar()" routerLink="/investment">
              <i class="fas fa-ellipsis-h"></i> Investment/Trading
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="closeSideBar()" routerLink="/dining">
              <i class="fa-duotone fa-burger-soda"></i> Dining
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="closeSideBar()" routerLink="/others">
              <i class="fas fa-ellipsis-h"></i> Others
            </a>
          </li>
          <li class="nav-title">Contact</li>
          <li class="nav-item">
            <a class="nav-link" (click)="closeSideBar()" routerLink="/manufacturing-date-checker">
              <i class="fas fa-search"></i> Batch Checker
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="closeSideBar()" routerLink="/contact-us">
              <i class="fas fa-file-signature"></i> Contact Us
            </a>
          </li>
        </ul>
      </nav>
      <button class="sidebar-minimizer brand-minimizer" type="button" aria-label="Minimize sidebar"></button>
    </div>
    <main class="main" (click)="closeSideBar()"  >
      <div class="container-fluid">
           
            <router-outlet ></router-outlet>


      </div>

    </main>
  </div>  
<app-footer class="app-footer" >
  <div class="template-demo"> <button (click)="goToFb()" type="button" aria-label="Open MyReferralPromoCode on Facebook" class="btn btn-social-icon btn-facebook btn-rounded"><i aria-hidden="true" class="fab fa-facebook-f"></i></button> <button (click)="goToYt()" type="button" aria-label="Open MyReferralPromoCode on YouTube" class="btn btn-social-icon btn-youtube btn-rounded"><i aria-hidden="true" class="fab fa-youtube"></i></button></div>
</app-footer>
</body>
